module.exports = __webpack_public_path__ + "img/jpg.883b2f5c.svg";